import FacadeGlobal from '@/plugins/store/facades/facade-global';

export const fetchUserProfile = async ({ store }) => {
  const facadeGlobal = new FacadeGlobal(store);
  await facadeGlobal.fetchUserProfile();
  return facadeGlobal.userProfile();
};
